import { render, staticRenderFns } from "./SingleRideHeader.vue?vue&type=template&id=2ad68b61&scoped=true"
import script from "./SingleRideHeader.vue?vue&type=script&lang=js"
export * from "./SingleRideHeader.vue?vue&type=script&lang=js"
import style0 from "./SingleRideHeader.vue?vue&type=style&index=0&id=2ad68b61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad68b61",
  null
  
)

export default component.exports